import { useTranslation } from 'react-i18next';
import styles from './ErrorFallback.module.scss';

export function ErrorFallback() {
  const { t } = useTranslation();

  return (
    <main className={styles.shell}>
      <section className={styles.card}>
        <h1>{t('errorFallback.title')}</h1>
        <p>{t('errorFallback.copy')}</p>
        <div className={styles.actions}>
          <button type="button" onClick={() => window.location.reload()}>
            {t('errorFallback.reload')}
          </button>
          <a href="mailto:support@cedrum.app">{t('errorFallback.contactSupport')}</a>
        </div>
      </section>
    </main>
  );
}
